import React from 'react';
import { defineMessages, FormattedMessage, intlShape, injectIntl } from 'react-intl';
import Grid, { GridRow, GridCell } from 'common/mdc/grid';
import Main from 'common/mdc/layout';
import WidgetStatus from './widgets/status/status';
import WidgetConsumer from './widgets/consumer/consumer';
import WidgetSupply from './widgets/supply/supply';
import WidgetServer from './widgets/servers/widgetServer';
import WidgetFirmware from './widgets/firmware/firmware';
import ScrollContainer from 'common/mdc/scrollbar/container';
import WidgetStatusForLast4Hours from './widgets/statusForLast4Hours/statusForLast4Hours';
import WidgetStatusForLast75Mins from './widgets/statusForLast75Mins/statusForLast75Mins';

const messages = defineMessages({
  title: {
    id: 'title.dashboard',
    defaultMessage: 'Dashboard',
  },
});

const Dashboard = () => (
  <Main
    title={<FormattedMessage {...messages.title} />}
  >
    <Grid container className="main-dashboard">
      <ScrollContainer settings={{ suppressScrollX: true }}>
        <div>
          <Grid item xs={12} sm={6}>
            <GridRow>
              <GridCell>
                <WidgetStatus />
              </GridCell>
              <GridCell>
                <WidgetStatusForLast4Hours />
              </GridCell>
              <GridCell>
                <WidgetStatusForLast75Mins />
              </GridCell>
              <GridCell>
                <WidgetFirmware />
              </GridCell>
              <GridCell>
                 <WidgetServer />
              </GridCell>
              <WidgetConsumer />
              {/*<GridCell>
                <WidgetSupply />
              </GridCell>*/}
            </GridRow>
          </Grid>
        </div>
      </ScrollContainer>
    </Grid>
  </Main>
);

export default Dashboard;
